import Store from './stores';
import makeInspectable from 'mobx-devtools-mst';

const store = Store.create();
makeInspectable(store);

export default store;



// WEBPACK FOOTER //
// ./src/store.js